<template>
    <div>
        <div class="object-titlebox">
            <div class="object-titlebox-left">
                {{$t('message.item_device_management_setting')}}
            </div>
        </div>
        <div v-if="!isEnablePlan">
            <div class="object-item">
                <span v-html="$t('message.info_device_management_plan_restriction')"></span><br>
            </div>
        </div>
        <div v-else-if="!this.appData.tenantAdminUser">
            <div class="object-item">
                <span v-html="$t('message.error_cannot_device_management_by_denied')"></span><br>
            </div>
        </div>
        <div v-else class="object-inner-table">
            <div class="default-message" style="margin:12px 0px">
                <span v-html="$t('message.info_device_management_guide')"></span>
                <br><br>
                <span style="color:#d55169" v-html="$t('message.caution_device_management_need_client_version')"></span>
            </div>
            <div class="object-titlebox">
                <div class="object-titlebox-left">
                    <span v-t="'message.item_device_management_setting_label'"></span>
                </div>
                <div class="object-titlebox-right">
                    <button v-if="this.appData.tenantAdminUser" class="transparent-button" type="button"
                        v-on:click="showDialog()">
                        <img src="../../../../assets/edit.svg" />
                        <span class="normal-command-text" v-t="'message.common_action_edit'"></span>
                    </button>
                </div>
            </div>
            <div width="100%" class="object-item">
                <span>{{ getDeviceManagementText() }}</span>
            </div>
           <DeviceManagementSettingList v-if="deviceManagement" />
        </div>
        <DeviceManagementSettingEdit v-if="showDeviceManagementEdit" ref="DeviceManagementSettingEdit" :appData="appData"
            @save="setDeviceManagement" @cancel="showDeviceManagementEdit = false"></DeviceManagementSettingEdit>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import DeviceManagementSettingEdit from '@/components/pc/setting/devicemanagement/DeviceManagementSettingEdit.vue';
import DeviceManagementSettingList from '@/components/pc/setting/devicemanagement/DeviceManagementSettingList.vue';

export default {
    components: {
        DeviceManagementSettingEdit: DeviceManagementSettingEdit,
        DeviceManagementSettingList: DeviceManagementSettingList,
    },
    props: ['appData'],
    data() {
        return {
            deviceManagement: false,
            showDeviceManagementEdit: false,
        }
    },
    mounted: function () {
    },
    created: function () {
        this.deviceManagement = this.appData.deviceManagement;
    },
    computed: {
        isEnablePlan() {
            switch (this.appData.basicContract.planType) {
                case constants.LICENSE_PLAN_TALK_ENT:
                case constants.LICENSE_PLAN_LIVE_ENT:
                    return true;
                default:
                    return false;
            }
        },
    },
    methods: {
        getDeviceManagementText() {
            if (this.deviceManagement) {
                return commonUtil.getMessageText(this.$i18n, "item_value_used");
            } else {
                return commonUtil.getMessageText(this.$i18n, "item_value_nonUsed");
            }
        },
        showDialog() {
            this.showDeviceManagementEdit = true;
        },
        async setDeviceManagement(modifyTenantOptionRequest) {
            const newFlag = modifyTenantOptionRequest.deviceManagement;
            try {
                const res = await server.post('/modifytenantoption', modifyTenantOptionRequest)
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "info_device_management_setting_updated"));
                        this.deviceManagement = newFlag;
                        this.appData.deviceManagement = newFlag;
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "setDeviceManagement").replace("{code}", res.data.status));
                        break;
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "setDeviceManagement", error);
            } finally {
                this.showDeviceManagementEdit = false;
            }
        },
    },

}
</script>

<style scoped>
.object-value {
    padding: 10px 10px;
}

.object-title {
    padding: 10px 10px;
    font-size: 12px;
}

.header-value {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #848991;
    font-size: 12px;
}

.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}

.title-box-left {
    padding: 10px;
    padding-left: 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}

.detailed-header {
    width: 95%;
    background-color: #f6f6f6;
    margin-top: 20px;
    margin-bottom: 5px;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 12px;
}

.detailed-table {
    width: 95%;
    margin-left: 20px;
}

.detailed-tr {
    border-bottom: 1px #eee solid;
}

.detailed-left {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 40%;
}

.select-setting {
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
    width: 35%;
    height: 100%;
}

.vertical-line-addition {
    height: 100vh;
    margin: 0;
    padding: 0;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}

.code-guide-text {
    font-size: 16px;
    font-weight: 600;
    color: #5171cb;
}
</style>
